import request from "@/api/axios";
import { SYSTEM_SERVICE, AUTH_SERVICE } from "@/api/config/servicePort";

export const fetchSignatures = params => {
  return request.get({ url: SYSTEM_SERVICE + `/qywx/signatures`, params });
};

export const fetchUserId = params => {
  return request.get({ url: SYSTEM_SERVICE + `/qywx/userinfo`, params });
};

export const getAuthqywxUrl = (params: any): Promise<IResponse> => {
  return request.get({ url: SYSTEM_SERVICE + `/qywx/auth_url`, params });
};

export const getAuthwxUrl = (params: any): Promise<IResponse> => {
  return request.get({ url: SYSTEM_SERVICE + `/wx/auth_url`, params });
};

// 企业微信授权登录
export const getqywxlogin = (data: any): Promise<IResponse> => {
  return request.post({ url: AUTH_SERVICE + `/qywx/web/login`, data });
};

// 微信授权登录
export const getwxlogin = (data: any): Promise<IResponse> => {
  return request.post({ url: AUTH_SERVICE + `/wx/web/rzlogin`, data });
};

// 企业微信扫码授权登录
export const getscancodeqywxlogin = (data: any): Promise<IResponse> => {
  return request.post({ url: AUTH_SERVICE + `/qywx/login`, data });
};

// token登录
export const tokenLoginApi = (data: any): Promise<IResponse> => {
  return request.post({ url: AUTH_SERVICE + "/token_login", data });
};
